// 在 JSON 解析前保留检测列表、统计及验证明细中的 ID，避免大整数精度丢失。
export function parseVerifyResponse(response) {
  const idFields = ['id', 'tenantId', 'userId', 'taskId'];
  // 完整匹配字符串令牌，避免误改通知内容等字符串内部的文本。
  const tokens = /("(?:\\.|[^"\\])*")(\s*:\s*(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)(?=\s*[,}]))?/g;
  const json = response.replace(tokens, (token, key, value, number) => {
    if (!value || !idFields.includes(JSON.parse(key))) return token;
    if (!/^-?\d+$/.test(number)) {
      throw new Error('检测接口 ID 必须为整数字符串');
    }
    return `${key}${value.slice(0, -number.length)}"${number}"`;
  });
  return JSON.parse(json);
}
